export const ariaLabels = {
  describedBy: 'describedBy',
  labelledBy: 'labelledBy',
};
